import React from 'react';
import PropTypes from 'prop-types';

import Chip from '../Chip/Chip';
import { ChipsWrapper } from './ChipSelector.style';

const ChipSelector = ({
  options,
  onChipSelected,
  selectedChipId,
  className,
  id,
  size,
}) => (
  <ChipsWrapper id={id} className={className}>
    {options.map((chip) => {
      const isSelected = chip.id === selectedChipId;
      return (
        <Chip
          key={chip.id}
          id={chip.id}
          label={chip.label}
          size={size}
          icon={chip.icon}
          isSelected={isSelected}
          onClick={() => onChipSelected(chip.id)}
          deleteAction={chip.deleteAction}
          disabled={chip.disabled}
          hasError={chip.hasError}
          hasWarning={chip.hasWarning}
          status={chip.status}
        />
      );
    })}
  </ChipsWrapper>
);

ChipSelector.defaultProps = {
  size: 'small',
  id: undefined,
  className: undefined,
};

ChipSelector.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType,
      hasError: PropTypes.bool,
      hasWarning: PropTypes.bool,
      deleteAction: PropTypes.func,
      disabled: PropTypes.bool,
      status: PropTypes.string,
    })
  ).isRequired,
  size: PropTypes.oneOf(['small', 'xs']),
  onChipSelected: PropTypes.func.isRequired,
  selectedChipId: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
};

export default React.memo(ChipSelector);
